import React from "react";

export default function SavedDocInbox() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.25"
        d="M18.3333 16.3333V13.8333C18.3333 12.45 17.2083 11.3333 15.8333 11.3333H15C14.475 11.3333 13.975 11.575 13.6667 12L12.6667 13.3333C12.0333 14.1667 11.0417 14.6667 9.99999 14.6667C8.94999 14.6667 7.95832 14.1667 7.33332 13.3333L6.33332 12C6.01666 11.575 5.51666 11.3333 4.99999 11.3333H4.16666C2.78332 11.3333 1.66666 12.45 1.66666 13.8333V16.3333C1.66666 17.7083 2.78332 18.8333 4.16666 18.8333H15.8333C17.2083 18.8333 18.3333 17.7083 18.3333 16.3333Z"
        fill="#362B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6666 11.475C16.4 11.375 16.125 11.325 15.8333 11.325H15C14.475 11.325 13.975 11.5667 13.6666 11.9917L12.6666 13.325C12.0333 14.1583 11.0416 14.6583 9.99998 14.6583C8.94998 14.6583 7.95831 14.1583 7.33331 13.325L6.33331 11.9917C6.01665 11.5667 5.51665 11.325 4.99998 11.325H4.16665C3.86665 11.325 3.59165 11.375 3.33331 11.4667V5.48333C3.33331 3.64166 4.82498 2.14999 6.66665 2.14999H13.3333C15.1666 2.14999 16.6666 3.64166 16.6666 5.48333V11.4583V11.475ZM7.49998 8.19999C7.14998 8.19999 6.87498 8.47499 6.87498 8.82499C6.87498 9.16666 7.14998 9.44999 7.49998 9.44999H9.99998C10.3416 9.44999 10.625 9.16666 10.625 8.82499C10.625 8.47499 10.3416 8.19999 9.99998 8.19999H7.49998ZM6.87498 5.49166C6.87498 5.14166 7.14998 4.86666 7.49998 4.86666H12.5C12.8416 4.86666 13.125 5.14166 13.125 5.49166C13.125 5.83333 12.8416 6.11666 12.5 6.11666H7.49998C7.14998 6.11666 6.87498 5.83333 6.87498 5.49166Z"
        fill="#362B73"
      />
    </svg>
  );
}
